import React from 'react';
import { remove } from 'ramda';
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';

import {
  IUIPage,
  UIUrvalConditionObjectType,
} from '../../../../Types/UrvalTypes';
import Condition from '../Condition/Condition';
import {
  getTypeConditionObject,
  ITypeConditionInfo,
} from '../../Utils/urvalUtils';
import {
  setConditionObject,
  updateTypeConditionObject,
} from './Utils/PageUtils';
import ExtendedUrvalSidaHeader from './Components/ExtendedUrvalSidaHeader/ExtendedUrvalSidaHeader';
import UrvalSidaHeader from './Components/UrvalSidaHeader/UrvalSidaHeader';
import EDButton from '../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';

interface IProps {
  pageNr: number;
  page: IUIPage;
  setPage: (newPage: IUIPage) => void;
  removePage: (pageNr: number) => void;
  indention: number;
  existsMorePages?: boolean;
  disabled?: boolean;
  collectionName: string;
  toggleFieldDialog?: () => void;
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {
    color: theme.customProperties.Fade.DarkOnLight.mediumEmphasis,
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pageFooter: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end',
  },
  removePageButton: {
    margin: '0 0 0 -12px',
  },
  pageType: {
    display: 'flex',
  },
  pageLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

/**
 * En vy av en urvalpage. Olika conditions kan läggas till och tas bort.
 */
export class UrvalSida extends React.Component<IProps> {
  deleteConditionObject = (index: number) => {
    const newPage: IUIPage = {
      ...this.props.page,
      conditionObjects: remove(index, 1, this.props.page.conditionObjects),
    };
    this.props.setPage(newPage);
  };

  setConditionObject = (
    index: number,
    typeConditionInfo: ITypeConditionInfo | undefined,
    newConditionObject: UIUrvalConditionObjectType
  ) => {
    let newPage = setConditionObject(
      index,
      newConditionObject,
      this.props.page
    );

    if (typeConditionInfo) {
      newPage = updateTypeConditionObject(
        newPage,
        this.props.page.conditionObjects[index],
        newConditionObject,
        typeConditionInfo
      );
    }

    this.props.setPage(newPage);
  };

  handleRemovePageButtonClick = () => {
    this.props.removePage(this.props.pageNr);
  };

  renderHeader = (
    isExtended: boolean,
    typeConditionInfo: ITypeConditionInfo | undefined
  ) => {
    const { pageNr, indention, collectionName, disabled } = this.props;

    if (isExtended) {
      return (
        <ExtendedUrvalSidaHeader
          typeConditionInfo={typeConditionInfo}
          deletePage={this.handleRemovePageButtonClick}
          pageNr={pageNr}
          collectionName={collectionName}
          indention={indention}
          disabled={disabled}
          setConditionObject={this.setConditionObject}
        />
      );
    } else {
      return (
        <UrvalSidaHeader
          typeConditionInfo={typeConditionInfo}
          setConditionObject={this.setConditionObject}
          pageNr={pageNr}
          collectionName={collectionName}
          disabled={disabled}
        />
      );
    }
  };

  render() {
    const {
      classes,
      page,
      indention,
      existsMorePages,
      disabled,
      toggleFieldDialog,
    } = this.props;

    const typeConditionInfo = getTypeConditionObject(page.conditionObjects);

    const isExtendedPage = indention > 0;

    const showPageHeader = !isExtendedPage || Boolean(existsMorePages);

    const typeConditionIndex = typeConditionInfo ? typeConditionInfo.index : -1;

    return (
      <div className={classes.container}>
        <div className={classes.headerContainer}>
          {showPageHeader &&
            this.renderHeader(isExtendedPage, typeConditionInfo)}
          {showPageHeader && (
            <EDButton
              flat
              color="inherit"
              label="Välj fält"
              icon={<EDIcon iconType="edit" color="inherit" />}
              onClick={toggleFieldDialog}
            />
          )}
        </div>
        {page.conditionObjects.map(
          (conditionObject, index) =>
            index !== typeConditionIndex && (
              <Condition
                indention={indention}
                key={conditionObject.id + index}
                conditionObject={conditionObject}
                setConditionObject={this.setConditionObject}
                index={index}
                typeConditionInfo={typeConditionInfo}
                deleteConditionObject={this.deleteConditionObject}
                disabled={disabled}
              />
            )
        )}
      </div>
    );
  }
}

export default withStyles(UrvalSida, styles);
